import { ResponseModel } from '../../../projects/core/src/lib/core/model/ResponseModel';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { ContratoProvider } from 'projects/core/src/lib/core/provider/ContratoProvider';
import { CarteiraRecomendadaProvider } from 'projects/core/src/lib/core/provider/CarteiraRecomendadaProvider';
import FormatHelper from 'projects/core/src/lib/core/FormatHelper';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { RecomendacoesOpcoesPage } from './recomendacoes-opcoes.page';
import { RecomendacaoOpcoesModel } from 'projects/core/src/lib/core/model/RecomendacaoOpcoesModel';

export class RecomendacoesOpcoesViewModel {
    carteiraRecomendadaProvider = new CarteiraRecomendadaProvider()
    webSocket: WebSocket = null
    tryReconnect = 0
    recomendacaoModel = new RecomendacaoOpcoesModel()
    context: RecomendacoesOpcoesPage
    offset: number = 0
    LIMIT_LIST = 20
    contratoProvider = new ContratoProvider()

    setContext(context: RecomendacoesOpcoesPage) {
        this.context = context
    }

    getContext(): RecomendacoesOpcoesPage {
        return this.context
    }

    addOffset() {
        this.offset += this.LIMIT_LIST
    }

    resetOffset() {
        this.offset = 0
    }

    async setPreferenciaUsuario(tipoAtivo) {
        return await AppStorage.set(AppSession.CHAVE_TIPO_ATIVO_SELECIONADO_RECOMENDACOES, tipoAtivo)
    }

    async getPreferenciaUsuario(): Promise<string> {
        return await AppStorage.get(AppSession.CHAVE_TIPO_ATIVO_SELECIONADO_RECOMENDACOES)
    }

    async buscaContratos() {
        const retorno = await this.contratoProvider.listaContratosPorUsuario()
        this.getContext().setListaContratos(retorno)
    }

    async getRecomedacoesTodas(tipoAtivo: String) {
        const compra = await this.getListaRecomendacoesComprasRetrofit(tipoAtivo)

        const todas = [
            ...compra
        ]

        this.getContext().setListaRecomendacaoTodas(todas)
    }

    async getRecomedacoesEncerradasTodas(tipoAtivo: String) {
        const todas = await this.getListaRecomendacoesEncerradas(tipoAtivo)
        this.getContext().setListaRecomendacaoEncerrados(todas)
    }


    async getListaRecomendacoesCompra(tipoAtivo: String, idTipoRecomendacao: number) {
        let retorno = await this.recomendacaoModel.listaRecomendacoesCompra(tipoAtivo, idTipoRecomendacao, this.LIMIT_LIST, this.offset)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) { }
    }

    async getListaRecomendacoesVenda(tipoAtivo: String, idTipoRecomendacao: number) {
        let retorno = await this.recomendacaoModel.listaRecomendacoesVenda(tipoAtivo, idTipoRecomendacao, this.LIMIT_LIST, this.offset)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) { }
    }

    async getListaRecomendacoesComprasRetrofit(tipoAtivo: String, filtro?: String) {
        let retorno = await this.recomendacaoModel.listaRecomendacoesCompraRetrofit(tipoAtivo, this.LIMIT_LIST, this.offset, filtro)
        console.log(retorno.data);

        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) { }
    }

    async getListaRecomendacoesVendaRetrofit(tipoAtivo: String, filtro?: String) {
        let retorno = await this.recomendacaoModel.listaRecomendacoesVendaRetrofit(tipoAtivo, this.LIMIT_LIST, this.offset, filtro)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) { }
    }

    async getListaRecomendacoesEncerradas(tipoAtivo: String, filtro?: String) {
        let retorno = await this.recomendacaoModel.listaRecomendacoesEncerradasRetrofit(tipoAtivo, this.LIMIT_LIST, this.offset, filtro)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) { }
    }

    async initWebSocket(callback = null) {
        let self = this
        this.webSocket = await this.carteiraRecomendadaProvider.connectWebsocket()
        this.webSocket.onmessage = function (event) {
            self.handlerWebSocketMessage(event.data);
        }
        this.webSocket.onopen = function (evt) {
            console.log("onopen.");
            if (callback != null) callback()
        };
        this.webSocket.onclose = function (evt) {
            console.log("onclose.");
        };
        this.webSocket.onerror = function (evt) {
            console.log("Error!");
            if (self.tryReconnect < 3) {
                self.tryReconnect++;
                self.initWebSocket(callback)
            } else if (self.tryReconnect < 6) {
                setTimeout(() => {
                    self.tryReconnect++;
                    self.initWebSocket(callback)
                }, 5000)
            }
        };
    }

    handlerWebSocketMessage(data) {
        let split = data.split(":")
        let codigo = split[1]
        let cotacao = split[2]
        let variacao = split[3]

        let itemMap = this.getContext().listaAnaliseAtivosViewMap[codigo]

        if (!itemMap) return

        let ativo = this.getContext().listaAnaliseAtivosView[itemMap.lista][itemMap.indice]
        if (ativo.pontas.some(ponta => ponta.codigo === codigo) && ativo.pontas.some(ponta => ponta.preco_atual != cotacao)) {

            

            if (ativo.encerrada==0) {
                let contacaoWS = parseFloat(cotacao)
                let variacaoWS = parseFloat(variacao)

                const index = ativo.pontas.findIndex((e) => e.codigo === codigo)
                ativo.pontas[index].preco_atual = contacaoWS
                // ativo.pontas[codigo_ativo]variacao = variacaoWS
                if (!ativo.atingido && ((ativo.preco_atual >= ativo.objetivo_estrutura && ativo.compra == 1) || (ativo.preco_atual <= ativo.objetivo_estrutura && ativo.compra == 0))) {
                    this.getContext().showToast(`${ativo.ativo_objeto.codigo} atingido com sucesso!`)
                    ativo.atingido = true
                }
                ativo.viewEstadoCor = true
                setTimeout(() => {
                    ativo.viewEstadoCor = false
                }, 1500)
            }

           
        }
        /*
        if (ativo !== undefined && ativo.cotacao != cotacao && ativo.variacao != variacao) {
            ativo.preco_atual = parseFloat(cotacao)
            ativo.variacao = parseFloat(variacao)

            ativo.viewEstadoCor = true
            setTimeout(() => {
                ativo.viewEstadoCor = false
            }, 1500)

            ativo.cotacao_str = FormatHelper.formatCotacao(ativo.cotacao, ativo.prefixado, ativo.unidade)
            ativo.variacao_str = FormatHelper.formatVariacao(ativo.variacao)
        }
        */
    }

    finishWebSocket() {
        if (this.webSocket != null) {
            this.webSocket.close()
        }
    }

    sendMessageSocketByTipoAtivo(ativos: Array<String>) {
        this.webSocket.send("L:" + ativos.toString())
    }
}